export default __webpack_public_path__ + "static/media/d_contact.7a2fe915.png";